// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopPanel {
    height: 38px !important;
    min-height: 38px !important;
    max-height: 38px !important;
    pointer-events: auto;
    background: var(--appbuilder-background);
}

.left-panel {
    width: 350px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    border: 1px solid black;
    flex-shrink: 0;
    position: relative;
    /*overflow: hidden;*/
    min-width: 350px;
    max-height: calc(100vh - 38px);
    background: var(--appbuilder-background);
}
.right-panel {
    width: 330px;
    min-width:330px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    border: 1px solid black;
    flex-shrink: 0;
    position: relative;
    background: var(--appbuilder-background);
    /*overflow: hidden;*/
    /*min-width: 300px;*/
}

.top-entry {
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    align-self: center;
}

.top-entry:hover, .top-entry.active {
    background-color: white;
    background: var(--appbuilder-primary-color); /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to top, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px, var(--appbuilder-background) 3px, var(--appbuilder-background) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.navi-entry {
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    align-self: center;
    position: relative;
    height: 50px;
    display: flex;
    flex-shrink: 0;
}
.navi-entry.icon {
    width: 40px;
    justify-content: center;
}
.navi-entry:hover, .navi-entry.active {
    background-color: white;
    background: var(--appbuilder-primary-color); /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to left, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px,var(--appbuilder-background) 3px,var(--appbuilder-background) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

.navi-entry-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
.panelbutton {
    background: var(--appbuilder-primary-color);
    display: flex;
    align-items: center;
    color: var(--appbuilder-hover-color);
}

.resize-handle-left,
.resize-handle-right {
    position: absolute;
    height: 100%;
    cursor: col-resize;
    width: 5px;
    top:0;
    z-index:2;
}

.resize-handle-left {
    left: 0;
}

.resize-handle-right {
    right: 0;
}
.NaviPanel {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    height: 100%;
    background: var(--appbuilder-background);
    grid-template-rows: calc(100vh - 84px) 50px;
    display: grid;
}
.NaviPanelWrapper {
    display:flex;
    flex-direction:column;
    overflow:auto;
    grid-row-start:1;
    grid-row-end:1;
}
.NaviPanelEdit {
    width:100%; 
    grid-row-start: 2;
    grid-row-end: 2;
}
.navi-entry-remove-wrapper {
    position:absolute;
    top:2px;
    right:2px;
    width:20px;
    height:20px;
    border:1px solid red;
    border-radius:50%;
    background:red;
}
.navi-entry-remove-icon {
    width: 16px;
    height: 16px;
    line-height: 24px;
    color: white;
    padding-left: 2px;
}
.panel-tree-item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}
.SettingsArea {
    position: absolute;
    top:38px;
    left:40px;
    height:calc(100% - 38px);
    width:calc(100% - 50px);
    background: white;
    z-index:10;
}

.settings-item {
    position: absolute;
    top: -2px;
    right: -15px;
    display: inline-block;
    font-size: 9px;
    width: 40px;
    text-align: center;
    padding: 0.25em 0;
    color: white;
    transform: rotate( 45deg );
    border: 0px solid #fff;
    background: var(--appbuilder-primary-color);
}

.MainContentFull {
    width:100vw;
    height:100vh;
}
.MainContent {
    width: 100vw;
    height: calc(100vh - 38px);
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/common/menutabcontrol/menu.tab.control.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;IAC9B,wCAAwC;AAC5C;AACA;IACI,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,wCAAwC;IACxC,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,2CAA2C,EAAE,iBAAiB,EACuH,aAAa,EACX,4BAA4B;IACnN,gLAAgL,EAAE,qDAAqD;AAC3O;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;AACA;IACI,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,2CAA2C,EAAE,iBAAiB,EACwH,aAAa,EACb,4BAA4B;IAClN,+KAA+K,EAAE,qDAAqD;AAC1O;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,KAAK;IACL,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,2CAA2C;IAC3C,aAAa;AACjB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B","sourcesContent":[".TopPanel {\n    height: 38px !important;\n    min-height: 38px !important;\n    max-height: 38px !important;\n    pointer-events: auto;\n    background: var(--appbuilder-background);\n}\n\n.left-panel {\n    width: 350px;\n    z-index: 9;\n    display: flex;\n    flex-direction: column;\n    pointer-events: auto;\n    border: 1px solid black;\n    flex-shrink: 0;\n    position: relative;\n    /*overflow: hidden;*/\n    min-width: 350px;\n    max-height: calc(100vh - 38px);\n    background: var(--appbuilder-background);\n}\n.right-panel {\n    width: 330px;\n    min-width:330px;\n    z-index: 9;\n    display: flex;\n    flex-direction: column;\n    pointer-events: auto;\n    border: 1px solid black;\n    flex-shrink: 0;\n    position: relative;\n    background: var(--appbuilder-background);\n    /*overflow: hidden;*/\n    /*min-width: 300px;*/\n}\n\n.top-entry {\n    padding: 5px;\n    cursor: pointer;\n    overflow: hidden;\n    align-self: center;\n}\n\n.top-entry:hover, .top-entry.active {\n    background-color: white;\n    background: var(--appbuilder-primary-color); /* Old browsers */\n    background: -moz-linear-gradient(top, var(--appbuilder-primary-color) 0%, var(--appbuilder-primary-color) 3px, var(--appbuilder-background) 3px, var(--appbuilder-background) 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(top, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px, var(--appbuilder-background) 3px, var(--appbuilder-background) 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to top, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px, var(--appbuilder-background) 3px, var(--appbuilder-background) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n\n.navi-entry {\n    padding: 5px;\n    cursor: pointer;\n    overflow: hidden;\n    align-self: center;\n    position: relative;\n    height: 50px;\n    display: flex;\n    flex-shrink: 0;\n}\n.navi-entry.icon {\n    width: 40px;\n    justify-content: center;\n}\n.navi-entry:hover, .navi-entry.active {\n    background-color: white;\n    background: var(--appbuilder-primary-color); /* Old browsers */\n    background: -moz-linear-gradient(left, var(--appbuilder-primary-color) 0%, var(--appbuilder-primary-color) 3px, var(--appbuilder-background) 3px, var(--appbuilder-background) 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(left, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px,var(--appbuilder-background) 3px,var(--appbuilder-background) 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to left, var(--appbuilder-primary-color) 0%,var(--appbuilder-primary-color) 3px,var(--appbuilder-background) 3px,var(--appbuilder-background) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n}\n\n.navi-entry-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n.panelbutton {\n    background: var(--appbuilder-primary-color);\n    display: flex;\n    align-items: center;\n    color: var(--appbuilder-hover-color);\n}\n\n.resize-handle-left,\n.resize-handle-right {\n    position: absolute;\n    height: 100%;\n    cursor: col-resize;\n    width: 5px;\n    top:0;\n    z-index:2;\n}\n\n.resize-handle-left {\n    left: 0;\n}\n\n.resize-handle-right {\n    right: 0;\n}\n.NaviPanel {\n    width: 40px;\n    min-width: 40px;\n    max-width: 40px;\n    height: 100%;\n    background: var(--appbuilder-background);\n    grid-template-rows: calc(100vh - 84px) 50px;\n    display: grid;\n}\n.NaviPanelWrapper {\n    display:flex;\n    flex-direction:column;\n    overflow:auto;\n    grid-row-start:1;\n    grid-row-end:1;\n}\n.NaviPanelEdit {\n    width:100%; \n    grid-row-start: 2;\n    grid-row-end: 2;\n}\n.navi-entry-remove-wrapper {\n    position:absolute;\n    top:2px;\n    right:2px;\n    width:20px;\n    height:20px;\n    border:1px solid red;\n    border-radius:50%;\n    background:red;\n}\n.navi-entry-remove-icon {\n    width: 16px;\n    height: 16px;\n    line-height: 24px;\n    color: white;\n    padding-left: 2px;\n}\n.panel-tree-item {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n.SettingsArea {\n    position: absolute;\n    top:38px;\n    left:40px;\n    height:calc(100% - 38px);\n    width:calc(100% - 50px);\n    background: white;\n    z-index:10;\n}\n\n.settings-item {\n    position: absolute;\n    top: -2px;\n    right: -15px;\n    display: inline-block;\n    font-size: 9px;\n    width: 40px;\n    text-align: center;\n    padding: 0.25em 0;\n    color: white;\n    transform: rotate( 45deg );\n    border: 0px solid #fff;\n    background: var(--appbuilder-primary-color);\n}\n\n.MainContentFull {\n    width:100vw;\n    height:100vh;\n}\n.MainContent {\n    width: 100vw;\n    height: calc(100vh - 38px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
